export var OrderDirection;
(function (OrderDirection) {
    OrderDirection[OrderDirection["Ascending"] = 0] = "Ascending";
    OrderDirection[OrderDirection["Descending"] = 1] = "Descending";
})(OrderDirection || (OrderDirection = {}));
export var OrderField;
(function (OrderField) {
    OrderField[OrderField["Name"] = 0] = "Name";
    OrderField[OrderField["Modified"] = 1] = "Modified";
    OrderField[OrderField["Created"] = 2] = "Created";
    OrderField[OrderField["Shared"] = 3] = "Shared";
})(OrderField || (OrderField = {}));
